import React, { useState, useRef } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  // FaUpload,
  // FaTrash,
} from "react-icons/fa";
import "./ContactUs.css";
import {Link} from "react-router-dom";
import { Helmet } from 'react-helmet-async';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    // photoOfCollateral: null,
    collateralDescription: "",
  });

  // const [selectedImage, setSelectedImage] = useState(null);
  // const fileInputRef = useRef(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // const handleImageUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       photoOfCollateral: file,
  //     }));

  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setSelectedImage(reader.result); // Just for preview
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  // const removeImage = () => {
  //   setSelectedImage(null);
  //   setFormData((prevData) => ({ ...prevData, photoOfCollateral: null }));
  //   if (fileInputRef.current) {
  //     fileInputRef.current.value = "";
  //   }
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const payload = {
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      // photoOfCollateral: formData.photoOfCollateral,
      collateralDescription: formData.collateralDescription,
    };

    try {
      const response = await fetch("https://formspree.io/f/mjkyporg", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        alert("Application submitted successfully!");
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          // photoOfCollateral: null,
          collateralDescription: "",
        });
        // setSelectedImage(null);
        // if (fileInputRef.current) {
        //   fileInputRef.current.value = "";
        // }
      } else {
        alert("Error submitting application.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Failed to submit. Please try again.");
    }
  };

  return (
      <>
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Respected Solution",
              "url": "https://www.respectedsolution.co",
              "contactPoint": [{
                "@type": "ContactPoint",
                "telephone": "+2349037614599",
                "contactType": "customer service"
              }],
              "logo": "https://www.respectedsolution.co/logo.png"
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Respected Solution",
              "address": [
                {
                  "@type": "PostalAddress",
                  "streetAddress": "Suite N17-N19, Ikota Shopping Complex, Rd 4, Vgc, Ajah, Lekki 101222, Lagos.",
                  "addressLocality": "Lekki",
                  "postalCode": "101222",
                  "addressRegion": "Lagos",
                  "addressCountry": "NG"
                },
                {
                  "@type": "PostalAddress",
                  "streetAddress": "38b Adebayo Doherty Rd, Lekki Phase 1, Lekki 106104, Lagos",
                  "addressLocality": "Lekki",
                  "postalCode": "106104",
                  "addressRegion": "Lagos",
                  "addressCountry": "NG"
                }
              ],
              "telephone": "+2349037614599"
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Contact Us",
              "url": "https://www.respectedsolution.co/contact-us"
            })}
          </script>
        </Helmet>
        <div className="contact-hero">
          <h1>Contact Us</h1>
          <p>We’re here to assist you. Reach out to us anytime!</p>
        </div>

        <div className="contact-container">
          <div className="contact-form">
            <h2>Apply for Loan</h2>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label>Full Name</label>
                <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                />
              </div>

              <div className="input-group">
                <label>Email</label>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                />
              </div>

              <div className="input-group">
                <label>Phone Number</label>
                <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                    required
                />
              </div>

              <div className="input-group">
                <label>Description of Collateral (Optional)</label>
                <textarea
                    name="collateralDescription"
                    value={formData.collateralDescription}
                    onChange={handleChange}
                    placeholder="Describe your collateral (e.g. car, electronics, etc.)"
                    rows="4"
                />
              </div>

              {/*
            <div className="input-group">
              <label>Upload an Image (Optional)</label>
              <div className="file-upload">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  ref={fileInputRef}
                />
                <FaUpload className="upload-icon" />
              </div>

              {selectedImage && (
                <div className="image-preview-container">
                  <img
                    src={selectedImage}
                    alt="Uploaded Preview"
                    className="image-preview"
                  />
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={removeImage}
                  >
                    <FaTrash className="trash-icon" /> Remove Image
                  </button>
                </div>
              )}
            </div>
            */}

              <button type="submit" className="submit-btn">
                Send Message
              </button>
            </form>
          </div>

          <div className="contact-info">
            <h2>Our Contact Details</h2>
            <p onClick={() =>
                (window.location.href =
                    "https://maps.app.goo.gl/SEENu3i4dj52jHANA?g_st=iw")
            }>
              <FaMapMarkerAlt className="icon"/> Suite N17-N19, Ikota Shopping Complex, Rd 4, Vgc, Ajah, Lekki 101222, Lagos
            </p>
            <p onClick={() =>
                (window.location.href =
                    "https://maps.app.goo.gl/X33QQ9jwJLZqpPPo9?g_st=iw")
            }>
              <FaMapMarkerAlt className="icon"/> 38b Adebayo Doherty Rd, Lekki Phase 1, Lekki 106104, Lagos
            </p>
            <p>
              <FaPhoneAlt className="icon"/> +234 903 761 4599
            </p>
            <p>
              <FaEnvelope className="icon"/> info@respectedsolution.co
            </p>
          </div>
        </div>
      </>
  );
};

export default ContactUs;
